// Subtle decorative contour graphic — echoes the topographic line motif from ComIQ Insights.
// Kept faint and positioned away from question/reading content.
export const Contour = ({ className = "", tone = "mixed" }) => {
  const orange = "#F2541B";
  const ink = "#17140F";
  const lines = [
    { d: "M0 210 C 90 210, 105 70, 165 56 C 225 70, 240 210, 330 210", stroke: ink, op: 0.10 },
    { d: "M0 224 C 90 224, 108 96, 165 86 C 222 96, 240 224, 330 224", stroke: ink, op: 0.08 },
    { d: "M0 196 C 90 196, 102 46, 165 34 C 228 46, 240 196, 330 196", stroke: orange, op: tone === "ink" ? 0.10 : 0.38 },
  ];
  return (
    <svg
      viewBox="0 0 330 240"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="xMidYMid meet"
    >
      {lines.map((l, i) => (
        <path key={i} d={l.d} fill="none" stroke={l.stroke} strokeWidth={i === 2 ? 1.8 : 1.4} opacity={l.op} />
      ))}
      <circle cx="165" cy="34" r="3.5" fill={orange} opacity={tone === "ink" ? 0.5 : 1} />
    </svg>
  );
};
